export default async (to, from, next) => {
  _meta()
  next()
}
